import React, { memo } from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import makeStyles from "@material-ui/core/styles/makeStyles";

const helperTextStyles = makeStyles(() => ({
  root: {
    "&.Mui-disabled": {
      color: "#4C9C2E",
    },
  },
}));

const DriverPassword = ({ password }) => {
  const helperClass = helperTextStyles();

  return (
    !!password && (
      <Field
        component={TextField}
        name="password"
        defaultValue={password}
        type="text"
        label="New Password"
        disabled
        variant="outlined"
        helperText="Copied to clipboard"
        FormHelperTextProps={{ classes: helperClass }}
        data-testid="driver-password"
      />
    )
  );
};

export default memo(DriverPassword);
